export default "__VITE_ASSET__CmdxZVli__"